import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Box, Typography, Alert, Link } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const Register = () => {
  const navigate = useNavigate();
  const { register } = useAuth();  // 使用 AuthContext 的 register 函數
  const [formData, setFormData] = useState({
    email: '',
    username: '',
    password: '',
    confirmPassword: '',
    role: 'STUDENT'  // 默認角色為學生
  });
  const [error, setError] = useState('');
  const [isRegistered, setIsRegistered] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('密碼不匹配');
      return;
    }

    try {
      const { confirmPassword, ...submitData } = formData;
      const response = await register(submitData);
      console.log('Registration successful:', response);
      setIsRegistered(true);
      navigate('/verify-email', { 
        state: { 
          email: formData.email 
        }
      });
    } catch (error) {
      console.error('Registration error:', error);
      if (typeof error === 'string') {
        setError(error);
      } else if (error.email) {
        setError(`Email: ${error.email.join(', ')}`);
      } else if (error.username) {
        setError(`Username: ${error.username.join(', ')}`);
      } else if (error.password) {
        setError(`Password: ${error.password.join(', ')}`);
      } else {
        setError('註冊失敗，請稍後再試');
      }
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5">
          註冊
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mt: 2, width: '100%' }}>
            {error}
          </Alert>
        )}
        {isRegistered && (
          <Alert severity="success" sx={{ mt: 2, width: '100%' }}>
            註冊成功！請檢查您的電子郵件以完成驗證。
          </Alert>
        )}
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="電子郵件"
            name="email"
            autoComplete="email"
            autoFocus
            onChange={handleChange}
            value={formData.email}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label="使用者名稱"
            name="username"
            autoComplete="username"
            onChange={handleChange}
            value={formData.username}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="密碼"
            type="password"
            id="password"
            autoComplete="new-password"
            onChange={handleChange}
            value={formData.password}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="confirmPassword"
            label="確認密碼"
            type="password"
            id="confirmPassword"
            onChange={handleChange}
            value={formData.confirmPassword}
          />
          <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
            * 註冊後需要驗證電子郵件才能登入
          </Typography>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            註冊
          </Button>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2">
              已經有帳號？{' '}
              <Link 
                onClick={() => navigate('/login')}
                variant="body2" 
                sx={{ cursor: 'pointer' }}
              >
                立即登入
              </Link>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default Register; 